// 新聞文章內容區塊
'use client';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { setNewsBar } from '@/slices/popSlice';

import NewsContent from './NewsContent'; // 文章內容
import AsideCatalog from './AsideCatalog'; // 側邊新聞標題目錄
import NewsTags from './NewsTags'; // 新聞 tag 區塊
import NewsReference from './NewsReference'; // 新聞來源
import NewsSocial from './NewsSocial'; // 社群相關連結
import NewsKnowledge from './NewsKnowledge'; // 加密知識＋
import ExtendNews from '@/components/news/ExtendNews'; // 你可能想知道 新聞
import Upcoming from './Upcoming'; // 即將開始下一篇
import NewsFaq from './NewsFaq'; // 新聞常見問題
import NewsSchema from './NewsSchema'; // faq article schema
import NewsDisclaimer from './NewsDisclaimer'; // 免責聲明
import NewsWarning from './NewsWarning'; // 請勿轉載

import '../../styles/news.scss';

const NewsArticle = ({ news, locale, children, type }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [paragraph, setParagraph] = useState([]); // 側邊新聞標題目錄

    useEffect(() => {
        if (type === 'academy')
            dispatch(
                setNewsBar({
                    title: news?.title,
                    progress: 0,
                    newsId: news?.id,
                })
            );
    }, [type]);

    return (
        <>
            {/* faq article schema */}
            <NewsSchema news={news} />

            <div className="w-full mx-auto relative news-wrapper pt-[45px] uxl:pt-[28px]">
                <div className="mb-[100px]">
                    {/* 側邊標題目錄 */}
                    {paragraph?.length > 2 && (
                        <AsideCatalog paragraph={paragraph} t={t} id={news?.id} />
                    )}

                    {/* 文章主要區塊 */}
                    <section className="w-full max-w-[680px] mx-auto relative z-[1] selected-font">
                        {children}

                        {/* 文章內容 */}
                        <NewsContent
                            slides={news?.slides}
                            content={news?.content}
                            newsId={news?.id}
                            title={news?.title}
                            setParagraph={setParagraph}
                        />

                        {/* 常見問題回答 */}
                        {news?.faqTopic && <NewsFaq faqTopic={news?.faqTopic} t={t} />}

                        <div className="space-y-[20px]">
                            {/* 新聞標籤 */}
                            {!!news?.hashtags?.length && <NewsTags tags={news?.hashtags} />}

                            {/* 請勿轉載 */}
                            <NewsWarning t={t} />

                            {/* 免責聲明 */}
                            <NewsDisclaimer t={t} />

                            {/* 參考來源 */}
                            {!!news?.reference?.length && (
                                <NewsReference reference={news?.reference} t={t} />
                            )}

                            {/* 社群相關連結 */}
                            <NewsSocial />

                            {/* 加密知識＋ */}
                            {!!news?.knowList?.length && (
                                <NewsKnowledge t={t} knowList={news?.knowList} />
                            )}
                        </div>
                    </section>
                </div>

                {type !== 'academy' && (
                    <>
                        {/* 你可能想知道 推薦 */}
                        <ExtendNews newsId={news?.id} locale={locale} />

                        {/* 開始下一篇 */}
                        <Upcoming t={t} />
                    </>
                )}
            </div>
        </>
    );
};

export default NewsArticle;
